import { SelectionModel } from '@angular/cdk/collections';
import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSpinnerOverlayComponent } from 'src/app/components/mat-spinner-overlay/mat-spinner-overlay.component';
import { IFrotaModel } from 'src/app/frota/model/frota.model';
import { LoginModel } from 'src/app/model/login.model';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { LocalStorageService } from 'src/app/services/localstorage.service';
import { SnackBarService } from 'src/app/services/snack-bar-service.service';
import { ISubFrotaModel } from 'src/app/subFrota/model/subFrota.model';
import * as XLSX from 'xlsx';
import { AceitarAcordoDialogComponent } from '../aceitar-acordo-dialog/aceitar-acordo-dialog.component';
import { BuscaPostoDialogComponent } from '../busca-posto-dialog/busca-posto-dialog.component';
import { CancelarAcordoDialogComponent } from '../cancelar-acordo-dialog/cancelar-acordo-dialog.component';
import { CriarNovoAcordoComponent } from '../criar-novo-acordo/criar-novo-acordo.component';
import { EditarAcordoDialogComponent } from '../editar-acordo-dialog/editar-acordo-dialog.component';
import { FiltrarFrotaComponent } from '../filtrar-frota/filtrar-frota.component';
import { ModalPrecosDesatualizadosComponent } from '../modal-precos-desatualizados/modal-precos-desatualizados.component';
import { RecusarAcordoDialogComponent } from '../recusar-acordo-dialog/recusar-acordo-dialog-component';
import {
  AcordoRedeEspecialViewModel,
  AcordoStatus,
  AcordoStatusResponse,
  CombustivelContrato,
  GetAcordosPendentesFilterModel,
} from '../rede-especial.interface';
import { RedeEspecialService } from '../rede-especial.service';

@Component({
  selector: 'app-rede-especial-postos',
  templateUrl: './rede-especial-postos.component.html',
  styleUrls: ['./rede-especial-postos.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatExpansionModule,
    MatGridListModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTooltipModule,
    MatTableModule,
    MatCheckboxModule,
    MatSelectModule,
    MatSpinnerOverlayComponent,
    MatPaginatorModule,
    MatSortModule,
    ReactiveFormsModule,
  ],
})
export class RedeEspecialPostosComponent implements OnInit, AfterViewInit {
  @Output() selecionaPosto = new EventEmitter<number>();

  limparDatas() {
    this.filtroAcordosForm.patchValue({
      datVigenciaInicialDate: undefined,
      datVigenciaFinalDate: undefined,
    });
  }
  limpaFiltro() {
    if (this.filtroAcordosForm.get('nomeFrota')?.value) {
      this.filtroAcordosForm.patchValue({
        nomeFrota: undefined,
        codFrota: undefined,
      });
    }
  }

  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private service = inject(RedeEspecialService);
  private snackBar = inject(SnackBarService);
  public dialog = inject(MatDialog);
  private authenticationService = inject(AuthenticationService);
  private cdr = inject(ChangeDetectorRef);
  combustiveis!: CombustivelContrato[];
  statusAcordos!: AcordoStatus[];
  usuarioEhMacro: boolean = true;
  precosCombustiveisDesatualizados: boolean = false;
  /** Nome reduzido do posto para exibição no input */
  postoNomeReduzido: string = '';

  displayedColumns = [
    'selected',
    'codAcordo',
    'codAep',
    'datProposta',
    'datInicioVigencia',
    'datFimVigencia',
    'dscTipoAcordoPreco',
    'codPosto',
    'razaoSocialPosto',
    'codFrota',
    'razaoSocialFrota',
    'tipoCombustivel',
    'vlrPrecoTela',
    'vlrDescontoFixoAcordo',
    'vlrPrecoAcordo',
    'codAdc',
    'dscPeriodo',
    'numPrazo',
    'vlrMdr',
    // 'volumeMensalEstimado',
    'situacao',
  ];
  dataSource = new MatTableDataSource<AcordoRedeEspecialViewModel>([]);
  selection = new SelectionModel<AcordoRedeEspecialViewModel>(true, []);

  @ViewChild(MatSort, { static: false }) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  subFrota: ISubFrotaModel = {
    flagPadrao: 'N',
    flagCentroCusto: 'N',
    flagBloqueioPostoNovo: '0',
    enderecos: [
      { tipo: 'C', endereco: '', cep: '' },
      { tipo: 'B', endereco: '', cep: '' },
    ],
  };

  public loading: boolean = false;
  public usuario: LoginModel | undefined;
  frotaContatos!: IFrotaModel[];

  private diasParaRangeDoPeriodo = 720; // 2 aos de range

  public filter: GetAcordosPendentesFilterModel =
    {} as GetAcordosPendentesFilterModel;
  public acordos!: AcordoRedeEspecialViewModel[];

  today = new Date();
  ontem = new Date(
    new Date().setDate(new Date().getDate() - this.diasParaRangeDoPeriodo),
  );

  private localStorageService = inject(LocalStorageService);

  constructor() {
    try {
      var userData = this.localStorageService.getItem('userData');
      let u = JSON.parse(userData);

      if (u.retorno.tipo === 8) {
        this.usuarioEhMacro = false;
      } else {
        this.usuarioEhMacro = true;
        this.verificarPrecoDesatualizadoAsync();
      }
    } catch (error) {
      console.error('Não foi possivél recuperar o Macro', error);
    }
  }

  private verificarPrecoDesatualizadoAsync() {
    this.service.verificarPrecoDesatualizadoAsync().subscribe((res) => {
      //return res.sucesso && res.retorno;
      this.precosCombustiveisDesatualizados = res.retorno;

    });
  }

  isAllSelected() {
    const itensDaPaginaAtual = this.getItensDaPaginaAtual();

    if (itensDaPaginaAtual.length === 0) {
      return false;
    }

    // Verificar se todos os itens da página atual estão selecionados
    return itensDaPaginaAtual.every((item) => this.selection.isSelected(item));
  }

  getValorAbsoluto(valor: number): number | null {
    return Math.abs(valor) || null;
  }

  masterToggle() {
    if (!this.paginator) {
      this.isAllSelected()
        ? this.selection.clear()
        : this.dataSource.data.forEach((row) => this.selection.select(row));
      return;
    }

    const itensDaPaginaAtual = this.getItensDaPaginaAtual();

    if (this.isAllSelected()) {
      itensDaPaginaAtual.forEach((row) => this.selection.deselect(row));
    } else {
      itensDaPaginaAtual.forEach((row) => this.selection.select(row));
    }
  }

  filtroAcordosForm: FormGroup = new FormGroup({
    datPropostaInicialDate: new FormControl(this.ontem, [Validators.required]),
    datPropostaFinalDate: new FormControl(this.today, [Validators.required]),
    datVigenciaInicialDate: new FormControl(undefined),
    datVigenciaFinalDate: new FormControl(undefined),
    postoNomeReduzido: new FormControl(undefined),
    codPosto: new FormControl(undefined),
    nomePosto: new FormControl(undefined),
    codFrota: new FormControl(undefined),
    nomeFrota: new FormControl(undefined),
    tipoAcordo: new FormControl(undefined),
    statusAcordo: new FormControl(undefined),
    indCombustivel: new FormControl(undefined),
    codAcordo: new FormControl(undefined),
    codAep: new FormControl(undefined),
    codAdc: new FormControl(undefined),
  });

  ngOnInit(): void {
    // Configura o sorting customizado para datas e valores numéricos
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'datProposta':
          return new Date(item.datProposta).getTime();
        case 'datInicioVigencia':
          return item.datInicioVigencia
            ? new Date(item.datInicioVigencia).getTime()
            : 0;
        case 'datFimVigencia':
          return item.datFimVigencia
            ? new Date(item.datFimVigencia).getTime()
            : 0;
        case 'vlrPrecoTela':
        case 'vlrDescontoFixoAcordo':
        case 'vlrPrecoAcordo':
        case 'vlrMdr':
          return (
            Number(item[property as keyof AcordoRedeEspecialViewModel]) || 0
          );
        default:
          const value = item[property as keyof AcordoRedeEspecialViewModel];
          return typeof value === 'string'
            ? value.toLowerCase()
            : String(value || '');
      }
    };

    this.usuario = this.service?.usuario;

    this.authenticationService
      .validate(this.service?.usuario?.retorno?.guid ?? '')
      .then((dados) => {
        if (!dados.sucesso) {
          this.snackBar.flashMessage(
            this.authenticationService.msgSessaoExpirada,
            ['snackbar-error'],
            'Fechar',
            0,
          );
        } else {
          const parametro = this.route.snapshot.paramMap.get('param');
          this.getListaCombustiveis();
          this.getAcordoStatus();
          this.getAcordos(parametro ? parseInt(parametro) : undefined); // Se o parâmetro for fornecido, converte para nú<mero></mero>
        }
      })
      .catch(() => {
        this.snackBar.flashMessage(
          this.authenticationService.msgSessaoExpirada,
          ['snackbar-error'],
          'Fechar',
          0,
        );
        this.usuario = undefined;
      });
  }
  ngAfterViewInit() {
    // Aguarda um tick para garantir que as views estão inicializadas
    this.cdr.detectChanges();

    // Configura o sort e paginator após as views estarem inicializadas
    setTimeout(() => {
      if (this.sort) {
        this.dataSource.sort = this.sort;
      }
      if (this.paginator) {
        this.dataSource.paginator = this.paginator;
      }
    });
  }

  private getListaCombustiveis() {
    this.service
      .getListaCombustiveis(this.usuario?.retorno?.guid ?? '')
      .subscribe((res: CombustivelContrato[]) => {
        this.combustiveis = res;
      });
  }

  // funcao para tranformar datPropostaFinal:"2025-08-12T18:40:10.616Z" para "12/08/2025"
  private ajustarData(data?: string): string | undefined {
    if (data != undefined) {
      const date = new Date(data);
      const dia = String(date.getDate()).padStart(2, '0');
      const mes = String(date.getMonth() + 1).padStart(2, '0'); // Meses começam do zero
      const ano = date.getFullYear();
      return `${ano}-${mes}-${dia}`;
    } else {
      return undefined;
    }
  }

  private getAcordoStatus() {
    this.service.getAcordoStatus().subscribe((res: AcordoStatusResponse) => {
      if (res.sucesso) {
        this.statusAcordos = res.retorno;
      } else {
        this.snackBar.flashMessage(
          res.mensagem,
          ['snackbar-error'],
          'Fechar',
          2,
        );
      }
    });
  }

  private verificarCampoFrota(): boolean {
    if (
      this.filtroAcordosForm.get('nomeFrota')?.value != null &&
      this.filtroAcordosForm.get('codFrota')?.value == null
    ) {
      this.snackBar.flashMessage(
        'Clique na lupa do campo "Filtrar Frota" para selecionar uma frota!',
        ['snackbar-error'],
        'Fechar',
        0,
      );
      return false;
    } else {
      return true;
    }
  }

  public async getAcordos(statusAcordo?: number) {
    this.loading = !this.loading;

    try {
      let payload = {
        codFrota: this.filtroAcordosForm.get('codFrota')?.value,
        nomeFrota: this.filtroAcordosForm.get('nomeFrota')?.value,
        codPosto: this.filtroAcordosForm.get('codPosto')?.value,
        nomePosto: this.filtroAcordosForm.get('postoNomeReduzido')?.value,
        datPropostaInicial: this.ajustarData(
          this.filtroAcordosForm.get('datPropostaInicialDate')?.value,
        ),

        datPropostaFinal: this.ajustarData(
          this.filtroAcordosForm.get('datPropostaFinalDate')?.value,
        ),
        datVigenciaFinal: this.ajustarData(
          this.filtroAcordosForm.get('datVigenciaFinalDate')?.value,
        ),
        datVigenciaInicial: this.ajustarData(
          this.filtroAcordosForm.get('datVigenciaInicialDate')?.value,
        ),
        tipoAcordo: this.filtroAcordosForm.get('tipoAcordo')?.value,
        statusAcordo: this.filtroAcordosForm.get('statusAcordo')?.value,
        indCombustivel: this.filtroAcordosForm.get('indCombustivel')?.value,
        codAcordo: this.filtroAcordosForm.get('codAcordo')?.value,
        codAep: this.filtroAcordosForm.get('codAep')?.value,
        codAdc: this.filtroAcordosForm.get('codAdc')?.value,
      };

      this.selection.clear();

      // o payload nao pode enviar valores ques sejam null ou undefined
      let payloadLimpo = Object.fromEntries(
        Object.entries(payload).filter(
          ([_, value]) => value !== null && value !== undefined && value !== '',
        ),
      );

      if (this.verificarCampoFrota()) {
        this.dataSource.data = [];
        this.service.getAcordosPendentes(payloadLimpo).subscribe((res) => {
          this.loading = !this.loading;
          if (res.retorno?.length > 0) {
            var mappedAcordos = res.retorno.map((acordo) => {
              // mostra no grid a data de início de vigência, para os seguintes status de acordo:
              //  6	ACORDO VIGENTE
              //  10	ACORDO CANCELADO
              //  12	CANCELAMENTO SOLICITADO
              return {
                ...acordo,
                selected: false,
                datInicioVigencia: [6, 10, 12].includes(acordo.codSituacao)
                  ? acordo.datInicioVigencia
                  : '',
                dscTipoAcordoPreco: acordo.dscTipoAcordoPreco
                  ? acordo.dscTipoAcordoPreco.replace('R$', '')
                  : '',
              };
            });
            this.acordos = mappedAcordos;
            this.dataSource.data = this.acordos;
          }
        });
      } else {
        this.loading = !this.loading;
      }
    } catch (error) {
      this.snackBar.flashMessage(
        'Erro ao buscar lista de acordos!',
        ['snackbar-error'],
        'Fechar',
        2,
      );
      this.loading = !this.loading;
    }
  }

  private podemSerCanceladosOuRejeitados() {
    const acordosCancelaveisRejeitaveis: number[] = [1, 3, 6, 13, 17];

    var acordosNaoPodemSerCanceladosRejeitados: any =
      this.selection.selected.filter(
        (acordo): boolean =>
          !acordosCancelaveisRejeitaveis.includes(acordo.codSituacao),
      );

    if (acordosNaoPodemSerCanceladosRejeitados.length > 0) {
      var msg: string =
        'Não é possível cancelar ou recusar acordo com essa situação.';
      this.snackBar.flashMessage(msg, ['snackbar-error'], 'Fechar', 2);

      for (const acordo of acordosNaoPodemSerCanceladosRejeitados) {
        // desseleciona os acordos que não podem ser cancelados ou rejeitados
        this.selection.toggle(acordo);
      }
    }
  }

  dialogAceitarAcordo() {
    this.acordosQuePodemSerAprovados();

    // remover acordos que postos nao podem aprovar

    if (this.selection.selected.length > 0) {
      const dialogRef = this.dialog.open(AceitarAcordoDialogComponent, {
        data: this.selection.selected,
        width: '90vw',
        maxWidth: '600px',
        maxHeight: '90vh',
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.getAcordos();
        }
      });
    }
  }

  dialogRecusarAcordo() {
    this.podemSerCanceladosOuRejeitados();

    if (this.selection.selected.length > 0) {
      const dialogRef = this.dialog.open(RecusarAcordoDialogComponent, {
        data: this.selection.selected,
        width: '90vw',
        maxWidth: '600px',
        maxHeight: '90vh',
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.getAcordos();
        }
      });
    }
  }

  /*
  O Botão só pode estar habiltiado para acordo AEP, ou seja, precisa existir a coluna Codigo AEP preenchida no retorno da API de consulta do Evandro. E o status do Acordo deve ser Vigente (COD_ACORDO_STATUS = 6) ACORDO VIGENTE*/
  private mostrarAcordosNaoEditaveis() {
    var acordosQueNaoPodemSerEditados = this.selection.selected.filter(
      (acordo) => acordo.codSituacao != 6 || isNaN(acordo.codAep),
    );
    if (acordosQueNaoPodemSerEditados.length > 0) {
      var msg =
        'Os acordos que podem ser editados deve ser "ACORDO VIGENTE" e ser acordo AEP';
      this.snackBar.flashMessage(msg, ['snackbar-error'], 'Fechar', 2);

      for (const acordo of acordosQueNaoPodemSerEditados) {
        this.selection.toggle(acordo);
      }
    }
  }

  private acordosQuePodemSerAprovados() {
    const acordosAprovaveis: number = 17;

    var acordosNaoPodemSerAprovados: any = this.selection.selected.filter(
      (acordo): boolean => acordo.codSituacao !== acordosAprovaveis,
    );

    if (acordosNaoPodemSerAprovados.length > 0) {
      var msg: string = 'Não é possível aprovar acordo com essa situação.';
      this.snackBar.flashMessage(msg, ['snackbar-error'], 'Fechar', 2);

      for (const acordo of acordosNaoPodemSerAprovados) {
        // desseleciona os acordos que não podem ser aprovados
        this.selection.toggle(acordo);
      }
    }
  }

  dialogCancelarAcordo() {
    this.podemSerCanceladosOuRejeitados();

    if (this.selection.selected.length > 0) {
      const dialogRef = this.dialog.open(CancelarAcordoDialogComponent, {
        data: this.selection.selected,
        width: '90vw',
        maxWidth: '600px',
        maxHeight: '90vh',
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.confirmado) {
          this.getAcordos();
        }
      });
    }
  }

  abrirNovoAcordo() {
    // console.log('abrirNovoAcordo', this.precosCombustiveisDesatualizados);

    if (this.precosCombustiveisDesatualizados) {
      this.dialog.open(ModalPrecosDesatualizadosComponent, {
        width: '600vw',
        maxWidth: '600px',
        maxHeight: '200vh',
        });
    } else {
      const dialogRef = this.dialog.open(CriarNovoAcordoComponent, {
        width: '90vw',
        maxWidth: '800px',
        maxHeight: '90vh',
        data: this.combustiveis,
      });

      dialogRef.afterClosed().subscribe((result) => {
        this.getAcordos();
        if (result && result.sucesso) {
        }
      });
    }
  }

  dialogEditarAcordo() {
    this.mostrarAcordosNaoEditaveis();
    var acordosQuePodemSerEditados = this.selection.selected.filter(
      (acordo) => acordo.codSituacao == 6 && !isNaN(acordo.codAep),
    );

    if (acordosQuePodemSerEditados.length > 0) {
      const dialogRef = this.dialog.open(EditarAcordoDialogComponent, {
        width: '75vw',
        maxHeight: '90vh',
        data: {
          acordos: acordosQuePodemSerEditados,
          combustiveis: this.combustiveis,
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.sucesso) {
          this.getAcordos();
        }
      });
    } else {
      this.selection.clear();
    }
  }

  private getItensDaPaginaAtual(): AcordoRedeEspecialViewModel[] {
    const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
    const endIndex = startIndex + this.paginator.pageSize;

    // Retorna apenas os itens do intervalo atual da página
    return this.dataSource.filteredData.slice(startIndex, endIndex);
  }

  formatarDataExcel(data: string): string {
    if (!data) return '';
    const date = new Date(data);
    return date.toLocaleDateString('pt-BR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  }

  getDadosExcel() {
    var ret = this.dataSource.data.map((item) => {
      return {
        Acordo: item.codAcordo,
        'Cód. Aep': item.codAep,
        'Data da Proposta': this.formatarDataExcel(item.datProposta),
        'Data Inicio Vigência': this.formatarDataExcel(item.datInicioVigencia),
        'Data Fim Vigência': this.formatarDataExcel(item.datFimVigencia),
        'Tipo Acordo': item.dscTipoAcordoPreco,
        'Cód. Frota': item.codFrota,
        Frota: item.razaoSocialFrota,
        Combustível: item.tipoCombustivel,
        'Preço Bomba': item.vlrPrecoTela,
        Desconto: item.vlrDescontoFixoAcordo,
        'Preço Acordo': item.vlrPrecoAcordo,
        'Cód. Adc': item.codAdc,
        Período: item.dscPeriodo,
        Prazo: item.numPrazo,
        'Taxa Acordo': item.vlrMdr,
        Situação: item.situacao,
      };
    });
    return ret;
  }
  gerarNomeArquivo(): string {
    const agora = new Date();

    const ano = agora.getFullYear();
    const mes = String(agora.getMonth() + 1).padStart(2, '0');
    const dia = String(agora.getDate()).padStart(2, '0');
    const hora = String(agora.getHours()).padStart(2, '0');
    const minuto = String(agora.getMinutes()).padStart(2, '0');
    const segundo = String(agora.getSeconds()).padStart(2, '0');
    const usuario = this.usuario?.retorno?.codigoEntidade || ' ';
    const timestamp = `${ano}${mes}${dia}${hora}${minuto}${segundo}`;
    const nomeArquivo = `Acordos_${usuario}_${timestamp}`;

    return nomeArquivo;
  }

  exportToExel(): void {
    const workSheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
      this.getDadosExcel(),
    );
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, this.gerarNomeArquivo());
    XLSX.writeFile(workBook, `${this.gerarNomeArquivo()}.xlsx`);
  }

  gerenciarRetornoDialog(frota: IFrotaModel) {
    // console.log('Frota selecionada:', frota);
    if (frota) {
      // this.filtroacordos.nomeFrota = `${frota.codigo}: ${frota.nomeReduzido}`;
      // this.filtroacordos.codFrota = frota.codigo;
      this.filtroAcordosForm.patchValue({
        nomeFrota: `${frota.codigo}: ${frota.nomeReduzido}`,
        codFrota: frota.codigo,
      });
      //this.getAcordos();
    } else {
      // this.filtroacordos.nomeFrota = undefined;
      // this.filtroacordos.codFrota = undefined;
      this.filtroAcordosForm.patchValue({
        nomeFrota: undefined,
        codFrota: undefined,
      });
    }
    //this.getAcordos();
  }

  openDialog() {
    if (this.filtroAcordosForm.get('nomeFrota')?.value) {
      const dialogRef = this.dialog.open(FiltrarFrotaComponent, {
        width: '90vw',
        maxWidth: '700px',
        maxHeight: '80vh',
        //data: this.filtroacordos.nomeFrota,
        data: this.filtroAcordosForm.get('nomeFrota')?.value,
      });

      dialogRef.afterClosed().subscribe((result: IFrotaModel) => {
        this.gerenciarRetornoDialog(result);
      });
    }
  }

  scrollToTopAnimated() {
    const scrollToTop = () => {
      const c = document.documentElement.scrollTop || document.body.scrollTop;
      if (c > 0) {
        window.requestAnimationFrame(scrollToTop);
        window.scrollTo(0, 0);
        //window.scrollTo(0, c - c / 8);
      }
    };
    scrollToTop();
  }

  /**
   * Filtra o valor do input e abre o diálogo de busca de posto
   */
  filtrarEAbrirDialogPosto(): void {
    // Obtém o valor atual do input
    let valorInput = '';
    if (this.filtroAcordosForm.get('nomePosto')?.value) {
      valorInput = this.filtroAcordosForm.get('nomePosto')?.value;
    }

    // Configurações padrão para o diálogo
    let paramType = 'razaoSocial';
    let paramValue = valorInput;

    // Verifica se o input contém apenas números
    if (valorInput) {
      // Extrai os números do input (pode conter formato "123 - Nome do Posto")
      const numerosPossiveis = valorInput.match(/\d+/g);

      if (numerosPossiveis && numerosPossiveis.length > 0) {
        // Se encontrou números, assume que é um código de posto
        paramType = 'codPosto';
        paramValue = numerosPossiveis[0];
      }
    }

    this.dialog.open(BuscaPostoDialogComponent, {
      id: 'lupa',
      width: '90vw',
      maxWidth: '900px',
      height: '80vh',
      maxHeight: '600px',
      data: {
        mult: false,
        callback: (codPosto: number, nomePosto: string) => {
          this.postoNomeReduzido = `${codPosto}: ${nomePosto}`;
          this.filtroAcordosForm.patchValue({
            postoNomeReduzido: this.postoNomeReduzido,
            codPosto: codPosto,
            nomePosto: nomePosto,
          });

          // Emite evento com a lista atualizada
          this.selecionaPosto.emit(Number(valorInput));

          this.dialog.closeAll();
          //this.dialog.getDialogById('lupa')?.close();
        },
      },
    });

    // Acessa a instância do componente do diálogo para definir valores iniciais
    // Isso será feito em um setTimeout para garantir que o componente foi instanciado
    setTimeout(() => {
      const dialogComponent = this.dialog.openDialogs[0]
        ?.componentInstance as any;
      if (dialogComponent && dialogComponent.formSearch) {
        // Define o tipo de parâmetro (código ou texto)
        dialogComponent.formSearch.get('paramType')?.setValue(paramType);

        // Define o valor do parâmetro se tiver algum
        if (paramValue) {
          dialogComponent.formSearch.get('paramValue')?.setValue(paramValue);

          // Se tiver um valor válido, realiza a busca automaticamente
          if (paramValue.length > 0) {
            dialogComponent.search();
          }
        }
      }
    }, 300);
  }

  limparPostos() {
    if (this.filtroAcordosForm.get('postoNomeReduzido')?.value) {
      this.filtroAcordosForm.patchValue({
        postoNomeReduzido: undefined,
        nomePosto: undefined,
        codPosto: undefined,
      });
    }
  }
}
